import React, { useState } from "react";
import "../CSS/Chat.css";



const users = [
  { id: 1, name: "Inosuke", lastMessage: "Halo Dok", time: "19.30" },
  { id: 2, name: "Winter", lastMessage: "Halo Dok", time: "18.30" },
  { id: 3, name: "Louis", lastMessage: "Halo Dok", time: "17.50" },
  { id: 4, name: "Karens", lastMessage: "Halo Dok", time: "16.23" },
];

const Chat = () => {
  const [selectedUser, setSelectedUser] = useState(users[0]);
  const [messages, setMessages] = useState([
    { from: "user", text: "Halo admin!" },
    { from: "admin", text: "Halo juga, ada yang bisa dibantu?" },
  ]);
  const [newMessage, setNewMessage] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  const handleSend = () => {
    if (newMessage.trim() === "") return;
    setMessages([...messages, { from: "admin", text: newMessage }]);
    setNewMessage("");
  };

  // Filter user berdasarkan kata yang diketik
  const filteredUsers = users.filter((user) =>
    user.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="hep-chathelp">
      <div className="hep-main">
        <div className="hep-chat">
          {/* Sidebar Chat */}
          <div className="hep-chat-sidebar">
            <div className="hep-chat-search">
              <input
                type="text"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)} // update searchTerm
              />
              <i className="fas fa-search"></i>
            </div>

            <ul className="hep-chat-user-list">
              {filteredUsers.map((user) => (
                <li
                  key={user.id}
                  className={
                    selectedUser.id === user.id
                      ? "active hep-chat-user"
                      : "hep-chat-user"
                  }
                  onClick={() => setSelectedUser(user)}
                >
                  <div className="hep-chat-avatar">
                    <i className="fas fa-user-circle"></i>
                  </div>
                  <div className="hep-chat-user-info">
                    <p className="hep-chat-user-name">{user.name}</p>
                    <p className="hep-chat-user-msg">{user.lastMessage}</p>
                  </div>
                  <span className="hep-chat-user-time">{user.time}</span>
                </li>
              ))}

              {/* kalau hasil pencarian kosong */}
              {filteredUsers.length === 0 && (
                <p style={{ textAlign: "center", color: "gray", marginTop: "10px" }}>
                  Tidak ditemukan
                </p>
              )}
            </ul>
          </div>

          {/* Chat Main */}
          <div className="hep-chat-main">
            <div className="hep-chat-header">
              <div className="hep-chat-avatar">
                <i className="fas fa-user-circle"></i>
              </div>
              <div>
                <p className="hep-chat-header-name">{selectedUser.name}</p>
                <span className="hep-chat-status">Online</span>
              </div>
            </div>

            <div className="hep-chat-body">
              {messages.map((msg, index) => (
                <div
                  key={index}
                  className={`hep-chat-message ${
                    msg.from === "admin" ? "hep-admin-msg" : "hep-user-msg"
                  }`}
                >
                  {msg.text}
                </div>
              ))}
            </div>

            <div className="hep-chat-input">
              <input
                type="text"
                placeholder="Ketik pesan..."
                value={newMessage}
                onChange={(e) => setNewMessage(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleSend()}
              />
              <button onClick={handleSend}>
                <i className="fas fa-paper-plane"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Chat;
